import React, { memo } from 'react';

import { HouseCard } from '@/types/common';

interface ResultCardProps {
  house: HouseCard;
}

const ResultCard = ({
  house: {
    url,
    main_photo: image,
    city,
    title
  }
}: ResultCardProps) => (
  <a
    className="result-card"
    href={url}
  >
    {!!image && (
      <img
        src={image}
        alt={title}
      />
    )}

    {!!city && (
      <p>{city}</p>
    )}

    {!!title && (
      <h2>{title}</h2>
    )}
  </a>
);

export default memo(ResultCard);
